import { render } from "./SpecTable.vue?vue&type=template&id=5da8f4a3&scoped=true"
import script from "./SpecTable.vue?vue&type=script&lang=js"
export * from "./SpecTable.vue?vue&type=script&lang=js"

import "./SpecTable.vue?vue&type=style&index=0&id=5da8f4a3&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-5da8f4a3"

export default script